import { IItemForGetShortInfoWithStatus } from 'types';

export enum UserRoles {
	SUPER_USER = 'superUser',
	CLIENT_MANAGER = 'clientManager',
	GROUP_MANAGER = 'groupManager',
	RESTAURANT_MANAGER = 'restaurantManager',
	TECHNICAL = 'technical',
	WAITER = 'waiter',
	RKL_SUPPORT_MANAGER = 'rklSupport',
	NON_EXISTENT_ROLE = 'nonExistentRole',
}

export interface ILoggedUser {
	userId: string;
	user: string;
	role: '' | UserRoles;
	filePath: Nullable<string>;
	customers: Nullable<IItemForGetShortInfoWithStatus[]>;
	restaurants: Nullable<IItemForGetShortInfoWithStatus[]>;
}
